import { render } from "./TransportComponent.vue?vue&type=template&id=6cfdc468&scoped=true"
import script from "./TransportComponent.vue?vue&type=script&lang=js"
export * from "./TransportComponent.vue?vue&type=script&lang=js"

import "./TransportComponent.vue?vue&type=style&index=0&id=6cfdc468&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfdc468"]])

export default __exports__